import objectPath from 'object-path';
import objectValuePath from 'object-value-path';
import { DataEntity } from '../types/data';

export function capitalizeFirstLetter(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function getExpandedNodes(data: DataEntity | DataEntity[], pathname: string) {
  const nodes: string[] = [];
  const childNodePath = getFullPath(data, pathname);
  childNodePath.forEach((element, index: number) => {
    const node = objectPath.get(data, childNodePath.slice(0, -index + 1)) as DataEntity | undefined;
    if (node?.path) nodes.push(node.path);
  });
  return nodes;
}

export function getFullPath(obj: DataEntity | DataEntity[], pathname: string) {
  const data = JSON.parse(JSON.stringify(obj, (k, v) => (k === 'defaultReport' ? undefined : v)));
  return objectValuePath(data, pathname.replace(/\/$/, '')) as string[];
}

export function getDataEntity(obj: DataEntity | DataEntity[], fullpath: string[]): DataEntity | undefined {
  const target = objectPath.get(obj, fullpath);
  if (typeof target === 'string') return objectPath.get(obj, fullpath.slice(0, -1));
  return target[0];
}

export function findDefaultPath(data: DataEntity): string | null {
  if (data.report) return data.path;
  if (!data.children) return null;
  const findReport = (arr: DataEntity[]) => {
    if (!arr.length) return null;
    let result = null;
    arr.some((element) => {
      if (!!element.report) {
        result = element.path;
        return true;
      }
      if (element.children) {
        const child = findReport(element.children);
        if (child) {
          result = child;
          return true;
        }
      }
      return false;
    });
    return result;
  };
  return findReport(data.children);
}
